/* WRLD TAGS pin bundle, part 2 of 3: state, pricing and rendering.
   Load order: wt-pin-bundle.js, then this, then wt-pin-bundle-c.js.
   OFFER: with a cap, add 1 pin and get 1 more free. data-free-every=2,
   data-max-free=1 (set in snippets/wt-pin-bundle.liquid).
   The discount is NOT applied here. A Shopify automatic Buy X Get Y
   discount takes the money off. This only projects what it will do. */
(function () {
  'use strict';
  if (window.WTPinBundle) return;

  class PinBundle extends HTMLElement {
    connectedCallback() {
      this.freeEvery = parseInt(this.dataset.freeEvery, 10) || 2;
      this.maxFree = parseInt(this.dataset.maxFree, 10);
      if (isNaN(this.maxFree)) this.maxFree = Infinity;
      this.capPrice = parseInt(this.dataset.productPrice, 10) || 0;
      this.fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US',
        { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.track = this.querySelector('[data-wtb-track]');
      this.cards = Array.from(this.querySelectorAll('[data-wtb-card]'));
      this.picked = new Set();
      this.passthrough = false;
      if (!this.track || !this.cards.length) return;

      this.pins = this.cards.map(function (c) {
        return {
          variant: parseInt(c.dataset.variant, 10),
          price: parseInt(c.dataset.price, 10) || 0,
          title: c.dataset.title || '',
          zoom: c.dataset.zoomSrc || (c.querySelector('img') || {}).src || '',
          avail: c.dataset.available === 'true'
        };
      });

      const self = this;
      if (window.WTPinLightbox) {
        this.lb = new window.WTPinLightbox({
          pins: this.pins,
          money: function (c) { return self.money(c); },
          isPicked: function (i) { return self.picked.has(i); },
          onToggle: function (i) { self.toggle(i); }
        });
      }

      this.bind();
      this.hookForm();
      this.paintTiers();
      this.render();
      this.syncArrows();
    }

    freeCount(n) { return Math.min(Math.floor(n / this.freeEvery), this.maxFree); }

    pinCost(prices) {
      const s = prices.slice().sort(function (a, b) { return a - b; });
      return s.slice(this.freeCount(s.length)).reduce(function (a, b) { return a + b; }, 0);
    }

    money(c) { return this.fmt.format(c / 100); }

    paintTiers() {
      const u = this.pins.length ? this.pins[0].price : 0;
      const self = this;
      this.querySelectorAll('[data-tier-mult]').forEach(function (el) {
        el.textContent = self.money(u * (parseInt(el.dataset.tierMult, 10) || 1));
      });
    }

    toggle(i) {
      if (!this.pins[i] || !this.pins[i].avail) return;
      if (this.picked.has(i)) this.picked.delete(i); else this.picked.add(i);
      this.render();
    }

    updateButton(n, total) {
      if (!this.submitBtn) return;
      const span = this.submitBtn.querySelector('.btn-text') || this.submitBtn;
      if (this.originalText === undefined) this.originalText = span.textContent.trim();
      span.textContent = n === 0 ? this.originalText
        : 'Add cap + ' + n + ' pin' + (n === 1 ? '' : 's') + ' · ' + this.money(total);
    }

    render() {
      const self = this;
      const idxs = Array.from(this.picked);
      const n = idxs.length;
      const prices = idxs.map(function (i) { return self.pins[i].price; });
      const full = prices.reduce(function (a, b) { return a + b; }, 0);
      const cost = this.pinCost(prices);
      const save = full - cost;
      const free = this.freeCount(n);
      const total = this.capPrice + cost;
      const set = function (s, fn) { const e = self.querySelector(s); if (e) fn(e); };

      set('[data-wtb-picked]', function (e) {
        e.textContent = n === 0 ? 'No pins selected yet'
          : idxs.map(function (i) { return self.pins[i].title; }).join(', ');
      });
      set('[data-wtb-pinline]', function (e) { e.hidden = n === 0; });
      set('[data-wtb-pinlabel]', function (e) { e.textContent = n + ' pin' + (n === 1 ? '' : 's'); });
      set('[data-wtb-pinamt]', function (e) { e.textContent = self.money(full); });
      set('[data-wtb-saveline]', function (e) { e.hidden = save <= 0; });
      set('[data-wtb-savelabel]', function (e) {
        e.textContent = free === 1 ? 'Free pin' : free + ' free pins';
      });
      set('[data-wtb-saveamt]', function (e) { e.textContent = '-' + self.money(save); });
      set('[data-wtb-was]', function (e) {
        e.hidden = save <= 0; e.textContent = self.money(self.capPrice + full);
      });
      set('[data-wtb-total]', function (e) { e.textContent = self.money(total); });
      set('[data-wtb-fine]', function (e) { e.hidden = save <= 0; });
      set('[data-wtb-nudge]', function (e) {
        if (n === 0) { e.textContent = ''; return; }
        if (free >= self.maxFree) {
          e.textContent = (free === 1 ? '1 pin free. ' : free + ' pins free. ') +
            'You are saving ' + self.money(save) + '.';
          return;
        }
        const to = (self.freeEvery - (n % self.freeEvery)) % self.freeEvery;
        if (to === 1) e.textContent = 'Pick 1 more pin. That one is free.';
        else if (to > 1) e.textContent = 'Pick ' + to + ' more pins and one of them is free.';
        else e.textContent = free + ' pin' + (free === 1 ? '' : 's') +
          ' free. You are saving ' + self.money(save) + '.';
      });

      this.cards.forEach(function (card, i) {
        const on = self.picked.has(i);
        card.dataset.on = String(on);
        const t = card.querySelector('[data-wtb-toggle]');
        if (t) {
          t.setAttribute('aria-pressed', String(on));
          t.textContent = on ? '✓' : '+';
          t.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + self.pins[i].title);
        }
      });

      const tiers = this.querySelectorAll('.wtb__tier');
      const top = tiers.length;
      tiers.forEach(function (t) {
        t.classList.toggle('is-on',
          n > 0 && parseInt(t.dataset.tier, 10) === Math.min(n, top));
      });

      if (this.lb && this.lb.index !== null) this.lb.paintButton();
      this.updateButton(n, total);
    }
  }

  window.WTPinBundle = PinBundle;
})();
